/* @flow */
import * as React from 'react';
import Paper from '@material-ui/core/Paper';

import styles from './CentralForm.module.scss';

export type TypeProps = {
  // eslint-disable-line flow-prefer-exact-object-types
  children: React.Node,
  wide?: boolean,
};

function CentralForm(props: TypeProps) {
  const { children, wide } = props;

  return (
    <div className={styles['central-wrapper']}>
      <div className={`${styles['wrapper-inner']} ${wide ? styles.wide : ''}`}>
        <Paper className={styles['form-paper']}>{children}</Paper>
      </div>
    </div>
  );
}

export default CentralForm;
